import { useSearchParams } from 'react-router-dom';
export function useParam(name) {
    const [getParam, setParams] = useSearchParams();
    const paramValue = getParam.get(name);
    function setParamValue(value) {
        setParams(prev => {
            if (value) {
                prev.set(name, value);
            }
            else {
                prev.delete(name);
            }
            return prev;
        });
    }
    return [paramValue, setParamValue];
}
